import { mapActions } from 'vuex';
import i18n from '../i18n';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
export default {
  i18n: {
    messages: {
      en,
      fr,
    },
  },
  computed: {
    setChangeSaveAttr() {
      return {
        title: this.$i18n.t('tooltips.save'),
        'data-tooltip-pos': 'bottom',
      };
    },
  },
  methods: {
    ...mapActions('slides', ['reorderSlides']),
    showBorders(panels) {
      // Show borders by default
      panels.getButton('options', 'sw-visibility').set('active', 1);
    },
    addSaveOptions(panels) {
      let self = this;

      panels.addButton('options', {
        id: 'save-template',
        className: self.$route.name === 'segment' ? 'icon-save only-save' : 'icon-save',
        command: function() {
          var iconSave = document.querySelector('.icon-save');
          if (iconSave.classList.contains('icon-selected')) {
            self.editor.runCommand('save-template');
          }
        },
        attributes: this.setChangeSaveAttr,
      });
    },
    removeButtons(panels) {
      //remove button export template
      panels.removeButton('options', { id: 'export-template' });
      //remove button import template
      panels.removeButton('options', { id: 'gjs-open-import-webpage' });
    },
    loadScreens(panels) {
      panels.addPanel({
        id: 'disposition',
        visible: true,
      });
    },
    loadPages(panels) {
      panels.addPanel({
        id: 'pages',
        visible: true,
        buttons: [
          {
            id: 'btn-pages',
            // active by default
            className: 'fa fa-file page-list',
            label: '',
            active: false,
            // Built-in command
            command: 'list-page-show',
          },
        ],
      });
    },
    addPanels(panels) {
      var panelTop = { id: 'panel-top' };
      var panelBasicActions = {
        id: 'panel-basic',
      };
      panels.addPanel(
        Object.assign({}, panelTop, {
          el: '#panel__left',
        }),
      );
      panels.addPanel(
        Object.assign({}, panelBasicActions, {
          el: '#panel__list-page',
        }),
      );
    },
    addBeautifyTooltips(panels) {
      var self = this;
      // Add and beautify tooltips
      let tools = [
        'sw-visibility',
        'preview',
        'fullscreen',
        'preview-screens',
        'save-template',
        'undo',
        'redo',
        'canvas-clear',
        'gjs-open-import-webpage',
        'export-template',
      ];
      let blockTools = ['open-sm', 'open-layers', 'open-blocks'];
      tools.forEach(function(item) {
        if (panels.getButton('options', item)) {
          panels.getButton('options', item).set('attributes', {
            title: self.$i18n.t('tooltips.' + item),
            'data-tooltip-pos': 'bottom',
          });
        }
      });
      blockTools.forEach(function(item) {
        if (panels.getButton('views', item)) {
          panels.getButton('views', item).set('attributes', {
            title: self.$i18n.t('tooltips.' + item),
            'data-tooltip': self.$i18n.t('tooltips.' + item),
            'data-tooltip-pos': 'bottom',
          });
        }
      });
      var titles = document.querySelectorAll('*[title]');
      for (var i = 0; i < titles.length; i++) {
        var el = titles[i];
        var title = el.getAttribute('title');
        title = title ? title.trim() : '';
        if (!title) break;
        el.setAttribute('data-tooltip', title);
        el.setAttribute('title', '');
      }
    },
    scrollHorizontally(e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      this.$refs.ps.$el.scrollLeft -= delta * 40;
      e.preventDefault();
    },
    getList() {
      this.list = this.all;
    },

    dragSlide(event, position, moduleList) {
      let allSliders = document.querySelector('.scroll-area').getBoundingClientRect();
      let cardWrapper = document.querySelector('.card-wrapper');
      if (moduleList) {
        allSliders = document
          .querySelector('#' + moduleList + ' .scroll-area')
          .getBoundingClientRect();
        cardWrapper = document.querySelector('#' + moduleList + ' .card-wrapper');
      }
      if (cardWrapper) {
        let cardWidth = cardWrapper.clientWidth * 1.5;
        if (moduleList) {
          cardWidth = cardWrapper.clientWidth;
        }
        let cardPosition = event.clientX;
        if (event.originalEvent && event.originalEvent.clientX) {
          cardPosition = event.originalEvent.clientX;
        }
        const scrollToRightArea = allSliders.x + allSliders.width - cardWidth;
        const scrollToLeftArea = allSliders.x + cardWidth;
        if (cardPosition > scrollToRightArea || cardPosition < scrollToLeftArea || moduleList) {
          let delta = cardPosition > scrollToRightArea ? 1 : -1;
          let scroll = delta * 5;
          if (position) {
            delta = position;
            scroll = delta * scrollToLeftArea;
          }
          this.setScrollInterval(scroll, position);
        } else if (this.scrollInterval) {
          clearInterval(this.scrollInterval);
          this.scrollInterval = null;
        }
      }
    },
    setScrollInterval(scroll, position) {
      if (this.scrollInterval) {
        return;
      }
      if (this.$refs.ps) {
        if (position) {
          setTimeout(() => {
            this.$refs.ps.$el.scrollLeft += scroll;
          }, 20);
          this.$refs.ps.$el.style['scroll-behavior'] = 'smooth';
        } else {
          this.scrollInterval = setInterval(() => {
            if (this.$refs.ps) {
              this.$refs.ps.$el.scrollLeft += scroll;
            }
          }, 20);
        }
      }
    },
    removeSmoothing() {
      this.$refs.ps.$el.style['scroll-behavior'] = 'auto';
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/GrapesMixinPanels.js